export default __webpack_public_path__ + "imgs/b6f42ae7f4209bb7afbb6cfd56edcddb.jpg";